// @flow

import radio from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Radio';

import {
  createPartnerProgramAndBenefits,
  createBuildWorkflows,
  createHireExpert,
  createBuildIntegrations,
  createSellZapier,
  createHireBuildFullIntegration,
} from '../common/otherPartnershipQuestions';

const otherPartnershipQuestions = radio({
  id: 'otherpartnerquestions',
  label: 'Tell us more',
  zendeskCustomFieldId: 360044602391,
  items: [
    createPartnerProgramAndBenefits(false),
    createBuildWorkflows(false),
    createBuildIntegrations(false),
    createHireBuildFullIntegration(false),
    createHireExpert(false),
    createSellZapier(false),
  ],
});

export default otherPartnershipQuestions;
